/**
 * Define constants for mutations here so that there is a central store of what they are
 */
const path = 'widgets/_demo';
export const SET_FILTER_LIMIT = `${path}/SET_FILTER_LIMIT`;
